module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-regular-362b56e7c695512490276edce8bdac26.woff";